module.exports = __webpack_public_path__ + "static/img/kk_red.83232911.png";